export function getHoverActionIconStyles(
  themeColors: Record<string, string>,
  hoverColor: string,
) {
  return {
    root: {
      color: themeColors.textSecondary,
      transition: 'color 150ms ease, background-color 150ms ease',
      '&:hover:not([data-disabled])': {
        color: hoverColor,
        backgroundColor: `${hoverColor}18`,
      },
    },
  };
}

export function getHoverFilledActionIconStyles(
  themeColors: Record<string, string>,
  hoverColor: string,
  extraRootStyles: Record<string, string | number> = {},
) {
  return {
    root: {
      color: `${themeColors.textSecondary} !important`,
      backgroundColor: `${themeColors.formFields} !important`,
      border: `1px solid ${themeColors.border} !important`,
      transform: 'translateY(0) scale(1)',
      boxShadow: 'none',
      transition:
        'color 180ms ease, background-color 180ms ease, border-color 180ms ease, transform 180ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 180ms ease',
      ...extraRootStyles,
      '&:hover:not([data-disabled])': {
        color: '#ffffff !important',
        backgroundColor: `${hoverColor} !important`,
        borderColor: `${hoverColor} !important`,
        transform: 'translateY(-2px) scale(1.06)',
        boxShadow: `0 6px 16px ${hoverColor}55`,
      },
      '&:hover:not([data-disabled]) svg': {
        transform: 'scale(1.12)',
      },
      '&:active:not([data-disabled])': {
        transform: 'translateY(0) scale(0.96)',
        boxShadow: `0 2px 8px ${hoverColor}40`,
      },
      '& svg': {
        transition: 'transform 180ms cubic-bezier(0.22, 1, 0.36, 1)',
      },
    },
  };
}
